import {AString} from '@mintdata/mint-kit/api/values/AString';
import {AStringEnum} from '@mintdata/mint-kit/api/values/AStringEnum';

export class WordBreak extends AStringEnum
{
    public constructor(value:AString)
    {
        super(value, WordBreak.types);
    }

    public toString():string
    {
        return this.value ? this.value.toString() : null;
    }

    public static NORMAL = new AString('Normal');
    public static BREAK_ALL = new AString('Break All');
    public static BREAK_WORD = new AString('Break Word');

    public static types:Array<AString> = [
        WordBreak.NORMAL,
        WordBreak.BREAK_ALL,
        WordBreak.BREAK_WORD,
    ];

    public static getTextForOption(value:string):AString
    {
        const valueAsBreakWord = WordBreak.fromString(value);

        if( WordBreak.isNormal(valueAsBreakWord) )
            return new AString('Continue word on current line');

        if( WordBreak.isBreakAll(valueAsBreakWord) )
            return new AString('Continue letters in remaining space of line');

        if( WordBreak.isBreakWord(valueAsBreakWord) )
            return new AString('Put word on next line');
    }

    public static toCssWordBreakString(value:WordBreak):string
    {
        if( WordBreak.isNormal(value) )
            return 'normal';

        if( WordBreak.isBreakAll(value) )
            return 'break-all';

        if( WordBreak.isBreakWord(value) )
            return 'break-word';

        return 'normal';
    }

    public static normal():WordBreak
    {
        return new WordBreak(WordBreak.NORMAL);
    }

    public static breakAll():WordBreak
    {
        return new WordBreak(WordBreak.BREAK_ALL);
    }

    public static breakWord():WordBreak
    {
        return new WordBreak(WordBreak.BREAK_WORD);
    }

    public static isNormal(value:WordBreak):boolean
    {
        return value.value.value === WordBreak.NORMAL.value;
    }

    public static isBreakAll(value:WordBreak):boolean
    {
        return value.value.value === WordBreak.BREAK_ALL.value;
    }

    public static isBreakWord(value:WordBreak):boolean
    {
        return value.value.value === WordBreak.BREAK_WORD.value;
    }

    public static fromString(value:string):WordBreak
    {
        return new WordBreak(AString.fromString(value));
    }
}
